export const  enum Images {
    // HOME FOLDER
    BEAUTIFUL_STORIES = 'beautiful-stories',
    CREATE_AND_SHARE = 'create-and-share',
    DESIGNED_FOR_EVERYONE ='designed-for-everyone',
    // STORIES FOLDER
    DAYS_VOYAGE = '18-days-voyage',
    ARCHITECTURALS  ='architecturals',
    BEHIND_THE_WAVES =  'behind-the-waves',
    CALM_WATERS = 'calm-waters',
    CITYSCAPES = 'cityscapes',
    DARK_FOREST = 'dark-forest',
    KING_ON_AFRICA = 'king-on-africa',
    LAND_OF_DREAMS = 'land-of-dreams',
    LIGHT = 'light',
    MILKY_WAY = 'milky-way',
    MOON_OF_APPALACIA = 'moon-of-appalacia',
    THE_MOUNTAINS = 'mountains',
    RAGE_OF_THE_SEA = 'rage-of-the-sea',
    RUNNING_FREE = 'running-free',
    SOMWARPET = 'somwarpet',
    TRIP_TO_NOWHERE = 'trip-to-nowhere',
    UNFORESEEN_CORNERS = 'unforeseen-corners',
    WORLD_TOUR = 'world-tour',
    // FEATURES
    HERO = 'hero',
}
